import React from "react";

export default function SavedViewsPanel({
  views,
  activeViewId,
  onApplyView,
  onSaveAsView,
  onUpdateCurrentView,
  onDeleteView,
}) {
  const handleSaveAs = () => {
    const name = window.prompt("Nome da visão:", "Nova visão");
    if (name == null) return;
    onSaveAsView(name);
  };

  const handleDelete = (view) => {
    const confirmed = window.confirm(`Excluir a visão "${view.name}"?`);
    if (!confirmed) return;
    const result = onDeleteView(view.id);
    if (!result?.ok && result?.reason) window.alert(result.reason);
  };

  return (
    <section className="swb-panel">
      <div className="swb-panel__head">
        <h3>Visões (presets)</h3>
        <div className="swb-inline-actions">
          <button type="button" className="swb-btn" onClick={handleSaveAs}>
            Salvar visão
          </button>
          <button type="button" className="swb-btn" onClick={onUpdateCurrentView}>
            Atualizar visão ativa
          </button>
        </div>
      </div>

      <div className="swb-list">
        {(views || []).map((view) => (
          <div
            key={view.id}
            className={`swb-list-item ${view.id === activeViewId ? "is-active" : ""}`}
          >
            <div className="swb-list-item__content">
              <strong>{view.name}</strong>
              <span>
                {view.config?.groupBy || "machine"} · {(view.config?.visibleColumns || []).length} coluna(s)
                {view.isSystem ? " · sistema" : " · usuário"}
              </span>
            </div>
            <div className="swb-list-item__actions">
              <button type="button" className="swb-btn" onClick={() => onApplyView(view.id)}>
                Carregar
              </button>
              <button
                type="button"
                className="swb-btn swb-btn--danger"
                onClick={() => handleDelete(view)}
              >
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
